import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {AssignmentService} from "../../services/assignment.service";
import {AuthenticationService} from "../../services/authentication.service";
import {EmployeesService} from "../../services/employees.service";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../../services/helper.service";
import {TosterMessageService} from "../../services/toster-message.service";
import * as Highcharts from 'highcharts';
import {TrainingService} from "../../services/training.service";
import {TrainingDrillDownComponent} from "../training-drill-down/training-drill-down.component";
import {API_URL} from '../../config'

@Component({
  selector: 'app-employee-training-courses-modal',
  templateUrl: './employee-training-courses-modal.component.html',
//   styleUrls: ['./employee-training-courses-modal.component.scss'],
  providers: [TrainingService, EmployeesService, AssignmentService],
})


export class EmployeeTrainingCoursesModalComponent implements OnInit {

    auto_id: number;
    courseList: any;
    public masterData: any[];
    companySystemID = this.helperService.getSelectedCompanyId();

    constructor(
        private tosterMessageService: TosterMessageService,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private modalService: BsModalService,
        private helperService: HelperService,
        public bsModalRef: BsModalRef,
        private trainingService: TrainingService,
      ) {}
    

      closeModal() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason("questionbank_closed");
      }
    
      closeModalAfterCreate() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason("questionbank_closed");
      }
    


      ngOnInit() {
        //console.log(this.auto_id);
        this.getTrainingCourses();
      }


      getTrainingCourses() {
        this.trainingService
          .getTrainingCourses(this.companySystemID)
          .get()
          .subscribe(
            (resp) => {
              const data = JSON.parse(resp._body);
              this.masterData = data;
              //console.log(this.masterData);
              this.courseList = this.helperService.setSelect2DropDownOptions(
                this.masterData,
                "courseID",
                "courseName"
              );
              //console.log(this.courseList);
            },
            (error) => {
              //console.log(error);
            }
          );
      }

      

      addCourseEmployees(formData: any) {
        // this.spinner.show();
        const requestData = {
            course_id: formData.course_id,
            employee_id: this.auto_id,
            companySystemID: this.companySystemID,
        };
        //console.log(requestData);
    
        if(formData.course_id === undefined || formData.master_role_id === null) {
            this.tosterMessageService.showError("Sorry","Please select the course.");
            this.spinner.hide();
            return;
        }
    
        let that = this;
        that.trainingService
          .addCourseEmployees()
          .post(requestData)
          .subscribe(
            (resp: any) => {
              //console.log(resp);
              this.tosterMessageService.showSuccess(
                "Success",
                "Employee successfully added to the course."
              );
              that.closeModalAfterCreate();
            //   this.tableReload.emit();
              this.spinner.hide();
            },
            (error) => {
              //console.log(error);
              this.tosterMessageService.showError("Sorry","Invalid input!.");
              that.closeModalAfterCreate();
              this.spinner.hide();
            }
          );
        // this.tableReload.emit();
      }
    


}



// WEBPACK FOOTER //
// /app/src/app/shared-training/employee-training-courses-modal/employee-training-courses-modal.component.ts